/**
 * Functional extenders. Some required and convenient features are not supported by
 * the underscore.js (yet). And we (I) want to use that features right now.
 */
export default {
    /**
     * Creates a setter for a specific field in the object. Useful for simple callback actions. For example,
     * $q.when(someAsyncOperation, Fun.setter(item, 'asyncOpResult'));
     * @param {Object|Array} item object to set field on.
     * @param {String|int} field field name or index to set.
     * @returns {Function} Setter for the item[field]. This setter sets item[field] to its first argument.
     */
    'setter': function setter(item, field) {
        return function (value) {
            item[field] = value;
        };
    },

    /**
     * Creates a field getter function. Function will get a field with the specific name from the object.
     * @param {String} field field name.
     * @returns {*}
     */
    'fieldGetter': function fieldGetter(field) {
        return function (item) {
            return item[field];
        };
    },

    /**
     * Finds an index of item matching the predicate. Returns -1 if value was not found.
     * @param {*} items items (array) to search the item.
     * @param {Function} predicate predicate to check.
     * @returns {Number}
     */
    'indexWhere': function indexWhere(items, predicate) {
        for (var i = 0; i < items.length; i++) {
            if (predicate(items[i])) {
                return i;
            }
        }
        return -1;
    }
};


//////////////////
// WEBPACK FOOTER
// ./common/js/src/edge/api/gw-portals-util-js/FunUtil.js
// module id = 115
// module chunks = 0